import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { fetchPartnersAndContactsEffect } from '../effects/fetchPartnersAndContactsEffect'
import { initPartnerSearchFilters } from '../partnerSearchSlice'

listenerMiddleware.startListening({
  actionCreator: initPartnerSearchFilters,
  effect: fetchPartnersAndContactsEffect,
})
